<div class="form-buttons justify-right">
  <button class="submit-form-button pv-1-5p" [ngClass]="participantClassByRole" (click)="openNoteModal()">{{'addNoteText'|translate:translations}}</button>
</div>

<ul class="notes-list">
  @for (content of notesList; track content) {
    <li>
      {{content.note}}
      <div class="note-footer">
        <div class="note-date">{{content.lastUpdated | date: 'MMM dd, yyyy'}}</div>
        <div class="note-actions">
          <a (click)="openNoteModal(content.id)"><fa-icon [icon]="faPen"></fa-icon></a>
          <a (click)="deleteNote(content.id)"><fa-icon [icon]="faTrash"></fa-icon></a>
        </div>
      </div>
    </li>
  }
</ul>
<div class="clear"></div>
